import { v4 as uuidv4 } from 'uuid'

import { getBaseApi } from '../../src/Utils'

const baseApi = getBaseApi()

const postLog = (level: 'error' | 'warning' | 'info', message: string, payload?: Record<string, unknown>) => {
  void fetch(`${baseApi}/log/${level}`, {
    body: JSON.stringify({
      ...payload,
      correlationId: payload?.correlationId ?? uuidv4(),
      message,
      messageTemplate: message, // Using the message itself as the template for as the message is logged together with the preaded props in kibana
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    keepalive: true,
    method: 'POST',
  }).catch((error) => {
    console.error('Failed to send log payload', error)
  })
}

export const logFrontendError = (message: string, payload?: Record<string, unknown>) => postLog('error', message, payload)

export const logFrontendWarning = (message: string, payload?: Record<string, unknown>) => postLog('warning', message, payload)

export const logFrontendInfo = (message: string, payload?: Record<string, unknown>) => postLog('info', message, payload)
